import Vue from "vue";
import firebase from "firebase";
import firebaseApp from "@/main";
import Vuex, { GetterTree, MutationTree, ActionTree } from "vuex";

// Interfaces
import {
  AddNewExercise,
  NewExericse,
  ExerciseFirestore,
  formatExerciseId,
} from "@/interfaces/exercise.interface";

Vue.use(Vuex);

class State {
  baseAddNewExercises: AddNewExercise[] = [
    // Compounds
    {
      exerciseName: "Squat",
      type: "Barbell",
      bodyParts: ["Legs", "Quads", "Calves", "Glutes"],
      wantToAdd: false,
    },
    {
      exerciseName: "Bench Press",
      type: "Barbell",
      bodyParts: ["Chest", "Triceps"],
      wantToAdd: false,
    },
    // Hinge
    {
      exerciseName: "Deadlift",
      type: "Barbell",
      bodyParts: ["Lower Back", "Back", "Hamstrings", "Glutes"],
      wantToAdd: false,
    },
    {
      exerciseName: "Romanian Deadlift",
      type: "Barbell",
      bodyParts: ["Lower Back", "Back", "Hamstrings", "Glutes"],
      wantToAdd: false,
    },
    {
      exerciseName: "Good Morning",
      type: "Barbell",
      bodyParts: ["Lower Back", "Hamstrings", "Glutes"],
      wantToAdd: false,
    },
    {
      exerciseName: "Bent Over Row",
      type: "Barbell",
      bodyParts: ["Lower Back", "Lats", "Back", "Biceps"],
      wantToAdd: false,
    },
    {
      exerciseName: "Overhead Press",
      type: "Barbell",
      bodyParts: ["Shoulders", "Triceps", "Delts"],
      wantToAdd: false,
    },
    {
      exerciseName: "Lunge",
      type: "Barbell",
      bodyParts: ["Legs", "Quads", "Glutes"],
      wantToAdd: false,
    },
    // calisthenics
    {
      exerciseName: "Chest Dip",
      bodyParts: ["Chest", "Triceps"],
      type: "Weighted Bodyweight",
      wantToAdd: false,
    },
    {
      exerciseName: "Chin Up",
      bodyParts: ["Biceps", "Back"],
      type: "Weighted Bodyweight",
      wantToAdd: false,
    },
    {
      exerciseName: "Pull Up",
      bodyParts: ["Back", "Lats"],
      type: "Weighted Bodyweight",
      wantToAdd: false,
    },
  ];
}

const getters = <GetterTree<State, any>>{
  getBaseExercises(state): AddNewExercise[] {
    return state.baseAddNewExercises;
  },
  getUserCustomExercises(
    state,
    gettters,
    rootState,
    rootGetters
  ): NewExericse[] {
    if (rootGetters["userStore/isUserSignedIn"])
      return rootGetters["userStore/getUserData"].customExercises;
    return [];
  },
  getAllAddNewExercises(state, getters): AddNewExercise[] {
    const allAddNewExercises: AddNewExercise[] = state.baseAddNewExercises;

    getters.getUserCustomExercises.forEach((customExercise: NewExericse) => {
      allAddNewExercises.push({
        exerciseName: customExercise.exerciseName,
        type: customExercise.type,
        bodyParts: customExercise.bodyParts ? customExercise.bodyParts : [],
        wantToAdd: false,
      });
    });

    return allAddNewExercises;
  },
};

const mutations = <MutationTree<State>>{
  updateUserExercises(state, newExercise: AddNewExercise) {
    state.baseAddNewExercises.push(newExercise);
  },
};

const actions = <ActionTree<State, any>>{
  async addUserExercise({ rootGetters, commit }, newExericse: NewExericse) {
    let suc = true;
    if (rootGetters["userStore/isUserSignedIn"]) {
      const batch = firebase.firestore().batch();
      const userRef = firebaseApp
        .firestore()
        .collection("users")
        .doc(rootGetters["userStore/getUserUID"]);

      const exerciseName: string = formatExerciseId(
        newExericse.exerciseName,
        newExericse.type
      );

      // Update users customExercises field in firestore
      if (newExericse.isCustomExercise)
        batch.update(userRef, {
          customExercises: firebase.firestore.FieldValue.arrayUnion(
            newExericse
          ),
        });

      // Create a new document in users /exercise collection
      const newExercise: ExerciseFirestore = { ...newExericse, datesDone: [] };
      batch.set(userRef.collection("exercises").doc(exerciseName), newExercise);

      await batch.commit().catch((err) => {
        console.error(err);
        suc = false;
      });
    }
    if (suc) {
      const newExercise: AddNewExercise = {
        exerciseName: newExericse.exerciseName,
        bodyParts: newExericse.bodyParts,
        type: newExericse.type,
        wantToAdd: false,
      };
      commit("updateUserExercises", newExercise);
      return Promise.resolve();
    }
    return Promise.reject();
  },
};

const exerciseStore = {
  namespace: true,
  state: new State(),
  getters: getters,
  mutations: mutations,
  actions: actions,
};

export default exerciseStore;
